<template>
  <footer>
   <div class="container">
     <div class="row between-xs" id="contacts">
      <div class="col-xs-12 col-sm-3">
        <span><a href="tel:+81522298575" class="tel"><i class="fas fa-phone"></i>+81 (0) 52-229-8576</a></span>
      </div>
      <div class="col-xs-12 col-sm-9 right-col">
        <ul>
          <li><router-link to="contact" class="">{{'Contact Us' | language}}</router-link></li>
          <li><router-link to="for-owners" class="">{{'For Owners' | language}}</router-link></li>
          <li><router-link to="about-us" class="">{{'About Us' | language}}</router-link></li>
          <li><router-link to="rental-procedure" class="">{{'Rental Procedure' | language}}</router-link></li>
        </ul>
      </div>
     </div>

     <div class="row between-xs" id="legal">
       <div class="col-xs-12 col-sm-6">
           <ul>
             <li><router-link to="terms-and-conditions" class="legal-link">{{'Terms & Conditions' | language}}</router-link></li>
             <li><router-link to="privacy-policy" class="legal-link">{{'Privacy Policy' | language}}</router-link></li>
           </ul>
       </div>
        <div class="col-xs-12 col-sm-6 right-col">
          <p><strong>&copy; 2019 Japan Home Finder - All Rights Reserved | <a class="footer-dblink" target="_blank" href="https://digitalbridge.com.au">Web Design</a> by Digital Bridge</strong></p>
       </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: '',
    props: {
      msg: String
    }
  }
</script>

<style lang="scss" scoped>
  footer {
    padding: 1.5rem 0;
    background: $dark-grey;
    color: white;

    #contacts {
    }

    #legal {
      margin-top: .25em;

      strong {
        font-size: .85em;
        color: lighten($alternate-color, 45%);
        font-weight: 400;
      }
      .legal-link {
        font-size: .85rem;
      }
      .footer-dblink {
        font-weight: 400;
      }
    }

    a {
      padding-bottom: .1rem;
      border-bottom: 2px solid transparent;
      color: lighten($alternate-color, 45%);
      text-decoration: none;

      &.tel {
        font-size: .9em;

        .fas {
          font-size: .75em;
        }
      }

      &:hover {
        padding-bottom: .1rem;
        border-bottom: 2px solid darken($link-hover-color, 10%);
        color: lighten($alternate-color, 40%);
        text-decoration: none;
        transition: 300ms all ease;
      }
    }

    .container-fluid {
      max-width: 1200px;
    }

    .right-col {
      text-align: right;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        display: inline-block;
        margin: 0 .75em;

        &:first-child {
            margin-left: 0;
        }

        &:last-child {
            margin-right: 0;
        }
      }
    }

    @media (max-width: 767px) {
      .right-col {
        text-align: left;
      }

      #contacts {
        .right-col {
          margin-top: .5em;
        }
      }

      #legal {
        margin-top: 1em;

        strong, a {
          font-size: .75em;
        }
      }
    }

    @media (max-width: 600px) {
      ul {
        li {
          margin: 0 15px 0 0;

          a {
            font-size: .85em;
          }
        }
      }

      #legal {
        .right-col {
          line-height: .7em;
        }
      }
    }
  }
</style>
